(async () => {
  const config = window.COCORRINA_WAITLIST;
  const root = document.getElementById("cocorrina-waitlist-root");

  if (!config || !root) return;

  const defaults = {
    enabled: true,
    buttonLabel: "Join the Waitlist",
    modalHeading: "Join the Waitlist",
    modalIntro:
      "Leave your email and we’ll let you know when this piece returns.",
    emailLabel: "Email address",
    submitLabel: "Notify Me",
    successHeading: "You’re on the list",
    successMessage:
      "We’ll be in touch as soon as this piece is available again.",
    buttonBackground: "#251b17",
    buttonTextColor: "#f6eab0",
    modalBackground: "#f8f5ef",
    modalHeadingColor: "#251b17",
    modalTextColor: "#251b17",
    borderColor: "#7b684c",
    modalAccentColor: "#7b684c",
    modalFontFamily: "inherit",
    modalHeadingFont: "inherit",
modalBodyFont: "Futura, Arial, sans-serif",
modalButtonFont: "Futura, Arial, sans-serif",
    modalBackgroundImage: "",
    modalPaperImage: "",
    modalBackgroundImageMobile: "",
    modalPaperImageMobile: "",
  };

  let settings = defaults;

  try {
    const response = await fetch("/apps/reviews/waitlist-settings", {
      headers: {
        Accept: "application/json",
      },
      cache: "no-store",
    });

    if (response.ok) {
       
      const savedSettings = await response.json();

      settings = {
        ...defaults,
        ...savedSettings,
      };
    }
  } catch (error) {
    console.error("Could not load Cocorrina waitlist settings:", error);
  }

  if (!settings.enabled) return;

  const isSoldOut =
    config.available === false || Number(config.inventory) <= 0;

  if (!isSoldOut) return;

  const imageUrls = [
  settings.modalBackgroundImage,
  settings.modalPaperImage,
  settings.modalBackgroundImageMobile,
  settings.modalPaperImageMobile,
].filter(Boolean);

imageUrls.forEach((url) => {
  const image = new Image();
  image.src = url;
});

   const addToCartButton =
    document.querySelector(
      '.coco-product__details form[action*="/cart/add"] .btn--add-to-cart',
    ) ||
    document.querySelector(
      '.coco-product__details .btn--add-to-cart',
    ) ||
    document.querySelector('button[name="add"]') ||
    document.querySelector('input[name="add"]') ||
    document.querySelector('[id^="AddToCart"]') ||
    document.querySelector(
      'form[action*="/cart/add"] button[type="submit"]',
    ) ||
    document.querySelector(
      'form[action*="/cart/add"] input[type="submit"]',
    );

  if (!addToCartButton) {
    console.warn(
      "Cocorrina waitlist could not find the product button.",
    );
    return;
  }

  const button = document.createElement("button");

  button.type = "button";
  button.className = addToCartButton.className;

  // Remove disabled styling copied from the Coming Soon/Sold Out button.
  button.classList.remove(
    "btn--disabled",
    "disabled",
    "is-disabled",
  );

  button.classList.add("cocorrina-waitlist-button");
  button.textContent = settings.buttonLabel;
  button.style.width = "100%";
  button.disabled = false;
  button.removeAttribute("disabled");
  button.removeAttribute("aria-disabled");

  root.style.display = "block";
  root.style.width = "100%";
  root.style.maxWidth = "300px";
  root.style.margin = "12px auto 0";

  root.replaceChildren(button);

  const productForm = addToCartButton.closest(
    'form[action*="/cart/add"]',
  );

  if (productForm) {
    productForm.insertAdjacentElement("afterend", root);
  } else {
    addToCartButton.insertAdjacentElement("afterend", root);
  }

  const modal = document.createElement("div");

  modal.className = "cocorrina-waitlist-modal";
  modal.hidden = true;

  modal.innerHTML = `
    <div class="cocorrina-waitlist-modal__overlay"></div>

    <div
      class="cocorrina-waitlist-modal__dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cocorrina-waitlist-heading"
    >
      <div class="cocorrina-waitlist-modal__background">
        <div class="cocorrina-waitlist-modal__paper">
          <button
            type="button"
            class="cocorrina-waitlist-modal__close"
            aria-label="Close waitlist form"
          >
            ×
          </button>

          <div class="cocorrina-waitlist-modal__content">
            <h1 id="cocorrina-waitlist-heading"></h1>

            <p class="cocorrina-waitlist-modal__intro"></p>

            <form class="cocorrina-waitlist-form">
              <label>
                <span></span>

                <input
                  type="email"
                  name="email"
                  autocomplete="email"
                  required
                >
              </label>

              <button type="submit"></button>
            </form>
          </div>
        </div>
      </div>
    </div>
  `;

  function cssImage(value) {
    if (!value) return "none";

    const safeValue = String(value).replace(/["\\\n\r]/g, "");

    return `url("${safeValue}")`;
  }

  modal.style.setProperty(
    "--coco-waitlist-modal-bg",
    settings.modalBackground,
  );

  modal.style.setProperty(
  "--coco-waitlist-heading-color",
  settings.modalHeadingColor || settings.modalTextColor,
);

  modal.style.setProperty(
    "--coco-waitlist-modal-text",
    settings.modalTextColor,
  );

  modal.style.setProperty(
    "--coco-waitlist-border",
    settings.borderColor,
  );

  modal.style.setProperty(
    "--coco-waitlist-accent",
    settings.modalAccentColor,
  );

  modal.style.setProperty(
    "--coco-waitlist-button-bg",
    settings.buttonBackground,
  );

  modal.style.setProperty(
    "--coco-waitlist-button-text",
    settings.buttonTextColor,
  );

 modal.style.setProperty(
  "--coco-waitlist-heading-font",
  settings.modalHeadingFont || "Dahlia-MediumCondensed, Cormorant Garamond, serif",
);

modal.style.setProperty(
  "--coco-waitlist-body-font",
  settings.modalBodyFont ||
    "Futura, Arial, sans-serif",
);

modal.style.setProperty(
  "--coco-waitlist-button-font",
  settings.modalButtonFont ||
    "Futura, Arial, sans-serif",
);

  modal.style.setProperty(
    "--coco-waitlist-background-image",
    cssImage(settings.modalBackgroundImage),
  );

  modal.style.setProperty(
    "--coco-waitlist-paper-image",
    cssImage(settings.modalPaperImage),
  );

  modal.style.setProperty(
    "--coco-waitlist-background-image-mobile",
    cssImage(
      settings.modalBackgroundImageMobile ||
        settings.modalBackgroundImage,
    ),
  );

  modal.style.setProperty(
    "--coco-waitlist-paper-image-mobile",
    cssImage(
      settings.modalPaperImageMobile ||
        settings.modalPaperImage,
    ),
  );

  modal.querySelector(
    "#cocorrina-waitlist-heading",
  ).textContent = settings.modalHeading;

  modal.querySelector(
    ".cocorrina-waitlist-modal__intro",
  ).textContent = settings.modalIntro;

  modal.querySelector(
    ".cocorrina-waitlist-form label span",
  ).textContent = settings.emailLabel;

  modal.querySelector(
    ".cocorrina-waitlist-form button",
  ).textContent = settings.submitLabel;

  document.body.appendChild(modal);

  const closeButton = modal.querySelector(
    ".cocorrina-waitlist-modal__close",
  );

  const overlay = modal.querySelector(
    ".cocorrina-waitlist-modal__overlay",
  );

  const form = modal.querySelector(".cocorrina-waitlist-form");

  let closeTimer;

function openModal() {
  window.clearTimeout(closeTimer);

  modal.hidden = false;
  document.body.style.overflow = "hidden";

  // Force the browser to render the hidden state first.
  modal.getBoundingClientRect();

  requestAnimationFrame(() => {
    modal.classList.add("is-open");
  });

  window.setTimeout(() => {
    modal.querySelector('input[name="email"]')?.focus();
  }, 340);
}

function closeModal() {
  modal.classList.remove("is-open");
  document.body.style.overflow = "";

  closeTimer = window.setTimeout(() => {
    modal.hidden = true;
    button.focus();
  }, 340);
}

  button.addEventListener("click", openModal);
  closeButton?.addEventListener("click", closeModal);
  overlay?.addEventListener("click", closeModal);

  form?.addEventListener("submit", async (event) => {
  event.preventDefault();

  const emailInput = form.querySelector('input[name="email"]');
  const submitButton = form.querySelector('button[type="submit"]');
  const content = modal.querySelector(
    ".cocorrina-waitlist-modal__content",
  );

  if (!emailInput || !submitButton || !content) return;

  const email = emailInput.value.trim();

  if (!email || !emailInput.checkValidity()) {
    emailInput.reportValidity();
    return;
  }

  const originalButtonText = settings.submitLabel;

  submitButton.disabled = true;
  submitButton.textContent = "Joining…";

  let errorMessage = form.querySelector(
    ".cocorrina-waitlist-form__error",
  );

  if (!errorMessage) {
    errorMessage = document.createElement("p");
    errorMessage.className = "cocorrina-waitlist-form__error";
    errorMessage.setAttribute("role", "alert");
    form.appendChild(errorMessage);
  }

  errorMessage.textContent = "";

  try {
    const formData = new FormData();

    formData.append("email", email);
    formData.append("productId", config.productId || "");
    formData.append("productHandle", config.productHandle || "");
    formData.append("productTitle", config.productTitle || "");
    formData.append("variantId", config.selectedVariantId || "");
    formData.append(
      "variantTitle",
      config.selectedVariantTitle || "",
    );

    const response = await fetch(
      "/apps/reviews/waitlist-signup",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        body: formData,
      },
    );

    const result = await response.json();

    if (!response.ok || !result.success) {
      throw new Error(
        result.error || "Something went wrong. Please try again.",
      );
    }

    const wasAlreadyRegistered =
      result.status === "already_registered";

    content.replaceChildren();

    const heading = document.createElement("h1");
    heading.textContent = wasAlreadyRegistered
      ? "You’re already on the list"
      : settings.successHeading;

    const message = document.createElement("p");
    message.textContent = settings.successMessage;

    content.append(heading, message);
  } catch (error) {
    console.error("Waitlist submission failed:", error);

    errorMessage.textContent =
      error instanceof Error
        ? error.message
        : "Something went wrong. Please try again.";

    submitButton.disabled = false;
    submitButton.textContent = originalButtonText;
  }
});

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !modal.hidden) {
      closeModal();
    }
  });
})();